import { TranslateService } from '@ngx-translate/core';
import { isBefore, isSameDay } from 'date-fns';
import { lastValueFrom } from 'rxjs';

import { UsersApiService } from '@core/api-services/users-api/users-api.service';
import {
  Candidature,
  PolicyIssue,
  Sinister,
  SinisterDocumentType,
  SinisterThread,
  User
} from '@core/models';

export async function getUsers(
  userService: UsersApiService,
  user: User,
  sinister: Sinister,
  policy?: PolicyIssue,
  modification: boolean = false
): Promise<User[]> {
  const usersId: string[] = [];
  let users: User[] = [];

  let thread: SinisterThread[] = [];
  if (!!sinister && !modification) {
    thread = sinister.thread;
  } else if (!!sinister && modification) {
    thread = sinister.chat;
  } else if (!!policy && !modification) {
    thread = policy.thread;
  } else if (!!policy && modification) {
    thread = policy.chat;
  }

  thread.forEach((thread: SinisterThread) => {
    if (!usersId.includes(thread.userId)) {
      usersId.push(thread.userId);
    }
  });

  if (usersId.includes(user.id)) {
    const index = usersId.findIndex((id: string) => id === user.id);
    usersId.splice(index, 1);
  }

  const calls: Promise<User>[] = [];
  usersId.forEach((id: string) =>
    calls.push(lastValueFrom(userService.getUserSubscribe(id)))
  );

  try {
    users = await Promise.all(calls);
    users.push(user);
    return users;
  } catch (error) {
    return [];
  }
}

export function getSinisterBlobName(
  policyNumber: string,
  type: SinisterDocumentType,
  translate: TranslateService
): string {
  const suffix = translate.instant(`utils.sinister.sinister_blob_name.${type}`);
  return `${policyNumber}_${suffix}`;
}

export function base64ToBlob(
  base64: string,
  contentType: string = '',
  sliceSize: number = 512
): Blob {
  // Decodificar la cadena base64
  const byteCharacters: string = atob(base64);
  const byteArrays: Uint8Array[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice: string = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers: number[] = new Array(slice.length) as number[];
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray: Uint8Array = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  // Crear un objeto Blob a partir del array de bytes
  const blob: Blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function getSinisterDocLabel(
  type: SinisterDocumentType,
  translate: TranslateService
): string {
  return translate.instant(`utils.sinister.sinister_doc_label.${type}`);
}

export function isCandidatureClosed(candidature: Candidature): boolean {
  if (
    isSameDay(new Date(), new Date(candidature.expirationDate)) ||
    isBefore(new Date(candidature.expirationDate), new Date())
  ) {
    return true;
  } else if (!!candidature.selectDate || !!candidature.rejectDate) {
    return true;
  } else {
    return false;
  }
}
